import Vue from 'vue'

const state = {
    country_areas: [],
    faq_categories: [],
    library_file_categories: [],
    tags: [],
    library_file_extensions: [],
    group_users_labels: [],
    groups_user: []
}

const actions = {
    SET_LISTS(context, [site_lists]) {
        context.commit('SAVE_LISTS', [site_lists])
    }
}

const mutations = {
    SAVE_LISTS: (state, [site_lists]) => {
        Vue.set(state, 'country_areas', site_lists.country_areas)
        Vue.set(state, 'faq_categories', site_lists.faq_categories)
        Vue.set(state, 'library_file_categories', site_lists.library_file_categories)
        Vue.set(state, 'tags', site_lists.tags)
        Vue.set(state, 'library_file_extensions', site_lists.library_file_extensions)
        Vue.set(state, 'group_users_labels', site_lists.group_users_labels)
        Vue.set(state, 'groups_user', site_lists.groups_user)
    }
}

const getters = {
    country_areas: state => {
        return state.country_areas
    },

    faq_categories: state => {
        return state.faq_categories
    },

    library_file_categories: state => {
        return state.library_file_categories
    },

    tags: state => {
        return state.tags
    },

    library_file_extensions: state => {
        return state.library_file_extensions
    },

    group_users_labels: state => {
        return state.group_users_labels
    },

    groups_user: state => {
        return state.groups_user
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}